const {
  REACT_APP_API_URL: API_URL,
  NODE_ENV,
} = process.env

export {
  API_URL,
  NODE_ENV,
}
